export var types = {
    FORM_TEMPLATE_RETRIEVING: 'retrievingFormTemplate',
    FORM_TEMPLATE_RETRIEVED: 'formTemplateRetrieved',
};
export var mutations = {
    retrievingFormTemplate: function (state) {
        state.loading = true;
    },
    formTemplateRetrieved: function (state, payload) {
        state.formTemplate = payload.formTemplate;
        state.loading = false;
    },
};
